export const bankDialogDragDirective = {
    bind(el) {
        let Drag = el;
        let main = Drag.parentElement;
        Drag.onmousedown = function(event) {
            let ev = event || window.event;
            main = Drag.parentElement;
            let disX = ev.clientX - main.offsetLeft;
            let disY = ev.clientY - main.offsetTop;
            document.onmousemove = function(event) {
                let ev = event || window.event;
                main.style.left = ev.clientX - disX + "px";
                main.style.top = ev.clientY - disY + "px";
                // Drag.style.cursor = "move";
            };
        };
        Drag.onmouseup = function(event) {
            document.onmousemove = null;
        };
    }
};
